import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TooltipPosition, TooltipTheme } from '@shared/enum/tooltip.enums';
import { getCurrencySymbol } from '@shared/utils/helper';
import { Subject, takeUntil } from 'rxjs';
import { CurrencyService } from 'src/app/services/currency.service';
import { MarketplaceService } from 'src/app/services/marketplace/marketplace.service';

@Component({
    selector: 'app-price-details',
    templateUrl: './price-details.component.html',
    styleUrls: ['./price-details.component.scss'],
})
export class PriceDetailsComponent implements OnInit {
    TooltipPosition: typeof TooltipPosition = TooltipPosition;
    TooltipTheme: typeof TooltipTheme = TooltipTheme;
    isShowCancelPopup: boolean = false;
    isShowReschedulePopup: boolean = false;
    currency: any;
    priceMap: any = {
        adult: {
            fare_price: 'adult_fare_price',
            origin_price: 'origin_adult_fare_price',
            adjustment: 'adult_adjustment_price',
            membership: 'adult_membership_price',
        },
        child: {
            fare_price: 'child_fare_price',
            origin_price: 'origin_child_fare_price',
            adjustment: 'child_adjustment_price',
            membership: 'child_membership_price'
        },
        infant: {
            fare_price: 'infant_fare_price',
            origin_price: 'origin_infant_fare_price',
            adjustment: 'infant_adjustment_price',
            membership: 'infant_membership_price'
        }
    };
    serviceData = [
        {
            numSeat: 0,
            totalSeat: 0,
            numMeal: 0,
            totalMeal: 0,
            numExtraBaggage: 0,
            totalExtraBaggage: 0,
        },
        {
            numSeat: 0,
            totalSeat: 0,
            numMeal: 0,
            totalMeal: 0,
            numExtraBaggage: 0,
            totalExtraBaggage: 0,
        }
    ];
    collapsedStates: any[] = [];
    showNewVersion: boolean = false;
    targetPriceDetails: string = '';
    isCollapsedServiceChange: boolean = false;
    updateTicketPrice: number[] = [];
    currencySymbol: string = '$';
    private destroy$ = new Subject<void>();
    showMarketCurrencyOnly = true

    constructor(
        private currencyService: CurrencyService,
        private marketplaceService: MarketplaceService
    ) { }

    @Input() type?: string;
    @Input() flightDetail: any;

    ngOnInit(): void {
        this.marketplaceService.selectedMarketplace$
            .pipe(takeUntil(this.destroy$))
            .subscribe((value: any) => {
                if (!value) return;
                this.currencySymbol = getCurrencySymbol(value.currency);
            })
        this.showNewVersion = new Date(this.flightDetail?.booking_info?.booking_date) >= new Date('2025-04-02');
        this.targetPriceDetails = this.showNewVersion ? 'price_details' : 'price_details_old';
        this.currency = JSON.parse(localStorage.getItem('currency-conversation-data') || '');

        this.currencyService.receiveSignalChangeCurrency().subscribe(() => {
            // this.currencyService.updateCurrency();
            this.currency = JSON.parse(localStorage.getItem('currency-conversation-data') || '');

        });

        // Format service price and num
        if (this.flightDetail?.cs_passenger_information?.length) {
            this.flightDetail.cs_passenger_information.forEach((itinerary: any, index: number) => {
                itinerary.forEach((passenger: any) => {
                    // SEAT
                    if (passenger?.passenger_seat_list?.length) {
                        this.serviceData[index].numSeat += passenger.passenger_seat_list.length;
                        passenger.passenger_seat_list.forEach((seat: any) => {
                            this.serviceData[index].totalSeat += (seat.price ?? 0);
                        });
                    }
                    // EXTRA_BAGGAGE
                    if (passenger?.extra_baggage_list?.length) {
                        this.serviceData[index].numExtraBaggage += passenger.extra_baggage_list.length;
                        passenger.extra_baggage_list.forEach((baggage: any) => {
                            this.serviceData[index].totalExtraBaggage += (baggage.price ?? 0);
                        });
                    }
                    // MEAL
                    if (passenger?.extra_meal_list?.length) {
                        passenger.extra_meal_list.forEach((segment: any) => {
                            if (segment.meals?.length) {
                                segment.meals.forEach((meal: any) => {
                                    this.serviceData[index].numMeal += meal.quantity;
                                    this.serviceData[index].totalMeal += (meal.price ?? 0);
                                });
                            }
                        });
                    }
                });
            });
        } else {
            this.flightDetail.passenger_information.forEach((passenger: any) => {
                // SEAT
                if (passenger?.departure_seat?.length) {
                    this.serviceData[0].numSeat += passenger.departure_seat.length;
                    passenger.departure_seat.forEach((seat: any) => {
                        this.serviceData[0].totalSeat += seat.price;
                    });
                    this.flightDetail?.price_details?.price_details
                }
                if (passenger?.return_seat?.length) {
                    this.serviceData[1].numSeat += passenger.return_seat.length;
                    passenger.return_seat.forEach((seat: any) => {
                        this.serviceData[1].totalSeat += seat.price;
                    });
                }
                // EXTRA_BAGGAGE
                if (passenger?.departure_extra_baggage?.length) {
                    this.serviceData[0].numExtraBaggage += passenger.departure_extra_baggage.length;
                    passenger.departure_extra_baggage.forEach((baggage: any) => {
                        this.serviceData[0].totalExtraBaggage += baggage.price;
                    });
                }
                if (passenger?.return_extra_baggage?.length) {
                    this.serviceData[1].numExtraBaggage += passenger.return_extra_baggage.length;
                    passenger.return_extra_baggage.forEach((baggage: any) => {
                        this.serviceData[1].totalExtraBaggage += baggage.price;
                    });
                }
                // MEAL
                if (passenger?.departure_meals?.length) {
                    passenger.departure_meals.forEach((segment: any) => {
                        if (segment.meals?.length) {
                            segment.meals.forEach((meal: any) => {
                                this.serviceData[0].numMeal += meal.quantity;
                                this.serviceData[0].totalMeal += meal.price;
                            });
                        }
                    });
                }
                if (passenger?.return_meals?.length) {
                    passenger.return_meals.forEach((segment: any) => {
                        if (segment.meals?.length) {
                            segment.meals.forEach((meal: any) => {
                                this.serviceData[1].numMeal += meal.quantity;
                                this.serviceData[1].totalMeal += meal.price;
                            });
                        }
                    });
                }
            });
        }

        if (this.flightDetail?.price_details?.price_details?.length) {
            this.collapsedStates = this.flightDetail.price_details.price_details.map((item: any) => {
                return {
                    summary: true,
                    adult: true,
                    child: true,
                    infant: true,
                    taxes_charges: true
                }
            })
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['flightDetail'] && changes['flightDetail'].currentValue) {
            if (this.type === 'BOOKING_ISSUE' && this.flightDetail?.request_detail?.request_type === 'FINDING_FLIGHT') {
                const requestProcess = this.flightDetail.request_detail.request_process || [];
                this.findTicketPrices(requestProcess);
            } else if (this.type === 'BOOKING_HELPDESK') {
                const requestList = this.flightDetail?.request_list || [];
                for (const req of requestList) {
                    if (req?.request_type === 'FINDING_FLIGHT') {
                        const requestProcess = req.request_process || [];
                        this.findTicketPrices(requestProcess);
                        break;
                    }
                }
            }
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    findTicketPrices(requestProcess: any[]): void {
        this.updateTicketPrice = [];
        let hasDepartPrice = false;
        let hasReturnPrice = this.flightDetail?.flight_info?.one_way;

        for (let i = requestProcess.length - 1; i >= 0; i--) {
            const item = requestProcess[i];

            const departPrice = item?.flight_info?.[0]?.ticket_price?.price;
            if (!hasDepartPrice && departPrice) {
                this.updateTicketPrice[0] = departPrice;
                hasDepartPrice = true;
            }

            const returnPrice = item?.flight_info?.[1]?.ticket_price?.price;
            if (!hasReturnPrice && returnPrice) {
                this.updateTicketPrice[1] = returnPrice;
                hasReturnPrice = true;
            }

            if (hasDepartPrice && hasReturnPrice) {
                break;
            }
        }
    }


    showCancelPopup() {
        this.isShowCancelPopup = true;
    }

    closeCancelPopup() {
        this.isShowCancelPopup = false;
    }

    showReschedulePopup() {
        this.isShowReschedulePopup = true;
    }

    closeReschedulePopup() {
        this.isShowReschedulePopup = false;
    }

    collapseServiceChange() {
        this.isCollapsedServiceChange = !this.isCollapsedServiceChange
    }

    toggleCollapse(index: number, key: string) {
        this.collapsedStates[index][key] = !this.collapsedStates[index][key];
    }

    transformCurrency(value: number, showSymbol: boolean = true): any {
        let data = this.flightDetail.exchange_rate;
        if (showSymbol) {
            return (value * data.exchange_rate_value).toLocaleString('en-US', {
                style: 'currency',
                currency: data.currency_exchange_rate,
            });
        } else {
            return (value * data.exchange_rate_value).toLocaleString('en-US', {
                style: 'decimal',
                maximumFractionDigits: 2,
            });
        }
    }

    isSameCurrency() {
        if (this.currency?.currency?.toUpperCase() === this.flightDetail?.exchange_rate?.currency_exchange_rate?.toUpperCase()) {
            // if(this.flightDetail?.user_exchange_rate?.currency_exchange_rate){
            //     if(this.flightDetail?.user_exchange_rate?.currency_exchange_rate?.toUpperCase()==this.flightDetail?.exchange_rate?.currency_exchange_rate?.toUpperCase())
            //     {
            //         return true 
            //     }else{
            //         return false
            //     }
            // }
            // else{
            return true
            // }
        } else {
            return false
        }
    }

    transformCurrencyPayment(value: number, showSymbol: boolean = true): any {
    let data = this.flightDetail.exchange_rate;
    if (showSymbol) {
      return (value * data.exchange_rate_value).toLocaleString('en-US', {
        style: 'currency',
        currency: data.currency_exchange_rate,
      });
    } else {
      return (value * data.exchange_rate_value).toLocaleString('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2,
      });
    }
  }
}
